import { render, staticRenderFns } from "./crud-project-type.vue?vue&type=template&id=7e79da43&"
import script from "./crud-project-type.vue?vue&type=script&lang=js&"
export * from "./crud-project-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports